export const NOT_VERIFIED = 'not_verified';
export const VERIFIED_OK = 'ok';
export const VERIFIED_NOK = 'nok';
export const VERIFYING = 'verifying';